module.exports = __webpack_public_path__ + "images/e13a10a5cb8041a3c0c474bc9b0ecaa0.png";